var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 1L10.8889 3.33333",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11108 1L3.11108 5.66667",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11108 12.6666L3.11108 14.9999",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8889 10.3334L10.8889 15.0001",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8888 3.33339C11.6136 3.33339 11.976 3.33339 12.2619 3.4518C12.6431 3.60968 12.9459 3.91251 13.1038 4.29366C13.2222 4.57953 13.2222 4.94193 13.2222 5.66672C13.2222 6.39152 13.2222 6.7539 13.1038 7.03981C12.9459 7.42092 12.643 7.72379 12.2619 7.88168C11.976 8.00006 11.6136 8.00006 10.8888 8.00006C10.164 8.00006 9.80164 8.00006 9.51577 7.88168C9.13462 7.72379 8.83179 7.42092 8.67391 7.03981C8.5555 6.7539 8.5555 6.39152 8.5555 5.66672C8.5555 4.94193 8.5555 4.57953 8.67391 4.29366C8.83179 3.91251 9.13462 3.60968 9.51577 3.4518C9.80164 3.33339 10.164 3.33339 10.8888 3.33339Z",
    stroke: "#212129",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.111 8C3.83581 8 4.19818 8 4.48409 8.11838C4.8652 8.27627 5.16807 8.57913 5.32596 8.96024C5.44434 9.24616 5.44434 9.60852 5.44434 10.3333C5.44434 11.0581 5.44434 11.4205 5.32596 11.7064C5.16807 12.0875 4.8652 12.3904 4.48409 12.5483C4.19818 12.6667 3.83581 12.6667 3.111 12.6667C2.38619 12.6667 2.02382 12.6667 1.73791 12.5483C1.3568 12.3904 1.05394 12.0875 0.896047 11.7064C0.777669 11.4205 0.777669 11.0581 0.777669 10.3333C0.777669 9.60852 0.777669 9.24616 0.896047 8.96024C1.05394 8.57913 1.3568 8.27627 1.73791 8.11838C2.02382 8 2.38619 8 3.111 8Z",
    stroke: "#212129",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSearch);
export default __webpack_public_path__ + "static/media/filter-search.6d8929582fcf1955c2b4e1ebec67b6e2.svg";
export { ForwardRef as ReactComponent };